import styled from "styled-components";

export default styled.div`
  cursor: pointer;

  .home-card {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    gap: 0.5rem;
    position: relative;
    height: fit-content;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    max-width: 650px;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: rgba(149, 157, 165, 0.3) 0px 8px 24px;
    }

    .card-home-text {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      justify-content: center;
      padding: 1rem;
      flex: 1;
    }

    .home-card-img {
      width: auto;
      flex: 1;
      max-width: 500px;
      height: 100%;
      aspect-ratio: 3 / 4;
      position: relative;

      padding: 0.5rem;
      display: block;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        object-fit: cover;
        min-height: auto;
        max-height: auto;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .home-card {
      flex-flow: column nowrap;

      .card-home-text {
      }

      .home-card-img {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        max-width: none;
        aspect-ratio: 1 / 1;
        max-height: 200px;

        img {
          width: auto;
          min-height: 150px;
          max-height: 200px;
        }
      }
    }
  }
`;
